import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {StatusTypeOptions} from '@models/ticket';
import Search, {SearchInputType} from '@components/custom/Search';

interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const SearchAliasComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;
  
  const inputs = [{
    name: "query",
    label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
    type: SearchInputType.TEXT,
    size: 12
  }, {
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: StatusTypeOptions,
    size: 12
  }, {
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type: SearchInputType.DATE,
    size: 12
  }, {
    name: "to",
    label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type: SearchInputType.DATE,
    size: 12
  }];
  
  return <Search inputs={inputs} search={search}/>
};

export default SearchAliasComponent;